var _style, _g, _path, _g2, _path2, _path3, _path4, _g3, _g4, _g5, _g6, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g7, _g8, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect12, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockerwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 620.2 502.7",
    style: {
      enableBackground: "new 0 0 620.2 502.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9BCC8F;}\n\t.st1{opacity:0.25;fill:#B32E5D;enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#EAEAEA;}\n\t.st4{fill:#BC8D75;}\n\t.st5{fill:#99345E;}\n\t.st6{fill:#DBA585;}\n\t.st7{fill:#DCA787;}\n\t.st8{fill:#1C468A;}\n\t.st9{fill:#47393D;}\n\t.st10{fill:#B32E5D;}\n\t.st11{fill:#B7A9D3;}\n\t.st12{fill:#163560;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000068636883924264676940000013386963008549757597_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.4,611.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.7,495c-37.2-17.6-89.4-116.7-15.2-209.6C103.9,227.3,31,104.2,168,27.5c89.5-50.1,285.6-13.9,391.7,125.6 c72.1,94.8,73.7,234.3,17,340.7L72.7,495z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M600.4,437.5c-15.8-6.5-302.8,34.9-306.4,46.1c-3.7,11.5,3.8,9.7,123.9,10l159.2,1.1 C581.9,482.1,595.8,449.7,600.4,437.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M645.1,437.5c-0.5-0.1-6.6-0.1-7.1-0.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.5,488c-198.9-78.6-282.2-46.1-288.3-46.1l4.4,10l5.2,9.9l4.2,6.7l4.1,5.7l4.8,5.8l7.2,7.3l10.1,8h84.1 C154.2,495.7,322.3,499.9,318.5,488"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.5,188.6c-0.1,0.2-0.6,1,0,1.8c0,0.1,0.1,0.1,0.1,0.1c7.6,4.6,30.4,23.1,30.4,36.1v27h-68.9v-27 c0-13.1,23.1-31.9,30.6-36.2c0,0,0,0,0,0c0.2-0.3,0.3-0.7,0.3-0.9c0-0.6-0.3-0.9-0.3-0.9c-7.5-4.4-30.6-23.1-30.6-36.2v-27h68.9v27 C199.1,165.5,176,184.3,168.5,188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.9,228.4c-0.4,6,0.8,19.1,0.7,25.3h-20.4v-27c0-13.1,23.1-31.9,30.6-36.2c0,0,0,0,0,0 c0.2-0.3,0.3-0.7,0.3-0.9c0-0.6-0.3-0.9-0.3-0.9c-7.5-4.4-30.6-23.1-30.6-36.2v-27h13.7l9.7,2.7v21.4c0,0-1,6.2,1.5,12.2 c2.4,6,7.6,25.4,7.5,27.9C162.5,192.1,150.5,218,149.9,228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.1,143.4c-4.2,0.1-11.4,0.8-23,3.7c-7.9,2-21.7,0.5-28.9-0.5c-2.5-0.4-4.8,1.6-4.8,4.2v3.1 c0,8.6,23.1,27.1,29.2,31.9c0.9,0.7,1.5,1.8,1.5,3v47.7c0,1.6-0.8,3.1-2.1,4.1c-4.8,3.4-12.9,13.2-12.9,13.2h30.6 c0,0-8.2-9.5-12.8-13c-1.1-0.8-1.7-2-1.7-3.4v-48.6c0-1.2,0.5-2.3,1.4-3c6-4.8,28.5-23.4,28.5-32v-5.4 C195.2,145.5,192.9,143.3,190.1,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.3,128.9h-73.9c-0.9,0-1.7-0.8-1.7-1.7v-6.1H203v6C203,128.1,202.2,128.9,201.3,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203,260.7h-77.3v-6.4c0-1,0.8-1.8,1.8-1.8h73.9c0.9,0,1.7,0.8,1.7,1.7V260.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131.6,257.9l37.8,2.8c-3.1-2.2-14.8-6.9-13.7-10.1c1.8-5.1,19,6.3,23.3,7.1c4,0.7,10.7,0.8,15.6,3 l11.5,6.1l-11.8,9.2c0,0-20,1.2-25.8,1.1c-9.5-0.1-37.3-13.7-37.7-15.4C130.4,258.6,131.6,257.9,131.6,257.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.2,266.8c0,0,14.4,9,10.1,36.8h-21c0,0,3.5-21.1-11.7-27L206.2,266.8z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.7,285.7c0,0-4.2,76.6,9.8,87.8c6.5,5.2,21.8,6.8,38.3,6.8c5.4,0,11-0.2,16.5-0.4c0,0,0,0,0,0 c21.7-1.1,41.2-3.8,41.2-3.8s56.4,2.9,53.6-32.1c0,0-6.6-10.6-15-13c-7.8-2.2-43.3,3.9-49.4,4.2c-6.8,0.3-54.9,11-56.9,10.2 c-2.1-0.8-7.6-19.6-7.9-32.3c-0.5-18.3-0.4-35.1-0.4-35.1L188.7,285.7z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 494.6,
    className: "st9",
    width: 609.7,
    height: 1.2
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M504.3,493.6H285.7c-5.5,0-10-4.5-10-10V28.4c0-5.5,4.5-10,10-10h218.6c5.5,0,10,4.5,10,10v455.1 C514.3,489.1,509.8,493.6,504.3,493.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 284.2,
    y: 96.6,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 397.3,
    y: 96.6,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 283.4,
    y: 163.7,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 396.4,
    y: 163.7,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 283.3,
    y: 231.3,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 283.8,
    y: 298.9,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 396.9,
    y: 298.9,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 283.7,
    y: 366.5,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 396.8,
    y: 366.5,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 282.9,
    y: 433.7,
    className: "st10",
    width: 109.2,
    height: 60.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 433.7,
    className: "st10",
    width: 109.2,
    height: 60.9
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M497.5,81.3H291.8c-4.2,0-7.7-1-7.7-2.1V29c0-1.2,3.4-2.1,7.7-2.1h205.7c4.2,0,7.7,1,7.7,2.1v50.2 C505.2,80.4,501.8,81.3,497.5,81.3z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M336.5,61.3h8v4.2h-12.4v-19h4.4V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M363.6,49.2c1.9,2,2.9,4.2,2.9,6.8s-0.9,4.9-2.8,6.8c-1.9,1.9-4.1,2.9-6.8,2.9c-2.6,0-4.8-1-6.7-2.9 c-1.9-2-2.9-4.2-2.9-6.9s0.9-5,2.8-6.9s4.1-2.9,6.8-2.9C359.5,46.2,361.7,47.2,363.6,49.2z M360.6,52.2c-1-1.1-2.3-1.6-3.7-1.6 c-1.4,0-2.7,0.5-3.7,1.6s-1.5,2.3-1.5,3.8s0.5,2.8,1.5,3.8c1,1.1,2.3,1.6,3.7,1.6c1.4,0,2.7-0.5,3.7-1.6s1.5-2.4,1.5-3.8 C362.1,54.6,361.6,53.3,360.6,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M386.1,63.6c-1.1,0.9-2.2,1.5-3.2,1.8c-1.1,0.3-2.3,0.4-3.7,0.4c-2.7,0-4.9-1-6.8-2.9 c-1.8-1.9-2.7-4.2-2.7-6.8c0-2.7,0.9-5,2.8-6.9c1.9-1.9,4.1-2.9,6.7-2.9c2.8,0,5,0.8,6.7,2.5l-1.6,3.5c-0.2-0.3-0.6-0.6-1.1-1 c-1-0.6-2.3-0.9-4-0.8c-1.4,0.1-2.6,0.7-3.6,1.7s-1.5,2.3-1.5,3.8s0.5,2.8,1.4,3.8c1,1,2.2,1.6,3.6,1.7c1.4,0.1,2.8-0.1,4-0.7 c0.5-0.2,1-0.5,1.3-0.9L386.1,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M406.5,46.5l-7.7,8.8l7.6,10.2H401l-5.1-6.8l-1.3,1.5v5.4h-4.4v-19h4.4v7.3l6.2-7.3L406.5,46.5L406.5,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M414.9,61.4h8.6v4.2h-13.1v-19h12.8v4.2h-8.4v3.5h6.3v4.2h-6.3L414.9,61.4L414.9,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M443.7,65.6h-5.3l-4.1-6.1h-1.5v6.1h-4.4V46.5h7.3c2,0,3.6,0.6,4.9,1.7c1.3,1.1,1.9,2.7,1.9,4.8 c0,2.5-1.2,4.6-3.4,5.7L443.7,65.6z M432.8,50.5v5.1h2.3c2,0,2.9-0.9,2.9-2.5c0-1.7-0.9-2.6-2.6-2.6H432.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M458.4,64.1c-1.3,1.1-2.9,1.6-4.7,1.6c-2.5,0-4.8-1-7-3.1l1.8-3.8c1.6,1.8,3.6,2.7,5.3,2.7 c1.5,0,2.3-0.5,2.3-1.5c0-0.9-1.4-1.6-3.1-2.3c-2.5-1-5.8-2.6-5.7-5.9c0-1.6,0.7-3,1.9-4c1.3-1.1,2.8-1.6,4.4-1.6 c2,0,4.1,0.8,6.4,2.5l-1.8,3.8c-1.7-1.4-3.2-2.1-4.6-2.1c-0.9,0-1.8,0.3-1.8,1.3s2.3,1.6,4.5,2.7c2.3,1.1,4.5,2.7,4.3,5.4 C460.5,61.6,459.8,63.1,458.4,64.1z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.9,134.2H355c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C372.3,132.2,370.3,134.2,367.9,134.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.9,134.2H472c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C489.3,132.2,487.3,134.2,484.9,134.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.9,198.2H355c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C372.3,196.2,370.3,198.2,367.9,198.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.9,198.2H472c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C489.3,196.2,487.3,198.2,484.9,198.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.9,269.2H355c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C372.3,267.2,370.3,269.2,367.9,269.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.9,333.2H355c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C372.3,331.2,370.3,333.2,367.9,333.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.9,333.2H472c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C489.3,331.2,487.3,333.2,484.9,333.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.9,405.2H355c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C372.3,403.2,370.3,405.2,367.9,405.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.9,405.2H472c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C489.3,403.2,487.3,405.2,484.9,405.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.9,469.2H355c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C372.3,467.2,370.3,469.2,367.9,469.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.9,469.2H472c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C489.3,467.2,487.3,469.2,484.9,469.2z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 396.4,
    y: 231.7,
    className: "st10",
    width: 109.2,
    height: 64.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.9,266.2H472c-2.4,0-4.5-2-4.5-4.5l0,0c0-2.4,2-4.5,4.5-4.5h12.9c2.4,0,4.5,2,4.5,4.5l0,0 C489.3,264.2,487.3,266.2,484.9,266.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerwait);
export default __webpack_public_path__ + "static/media/lockerwait.bf6dc70fecd7a2ff1711eb22f438581e.svg";
export { ForwardRef as ReactComponent };